
import {createContext, useState} from 'react'

const Context = createContext()

export const DiagnosisContextProvider = ({children}) => {
 const [allDiagnosis, setAllDiagnosis] = useState([])
 const [diagnosis, setDiagnosis] = useState([]);
 const [diagnosi, setDiagnosi] = useState({})
 const [loading, setLoading] = useState(false);
 const [message, setMessage] = useState({
  message: '',
  status: 200
 })


 return <Context.Provider value={{allDiagnosis, setAllDiagnosis, diagnosis, setDiagnosis, diagnosi, setDiagnosi, message, setMessage, loading, setLoading}}>
  {children}
 </Context.Provider>
}
export default Context